import styles from './styles.module.scss';

interface IStepTitleProps {
    title: string;
}

const StepTitle = ({title = ''}: IStepTitleProps) => {
    return <h1 className={styles.title}>{title}</h1>;
};

export default StepTitle;
